(() => {
  if (window.gpProductCart) return;
  window.gpProductCart = function (id, checkout) {
    const element = document.getElementById(id);
    if (!element || document.querySelector('.pe-all-blue.editing')) return;
    const control = element.querySelector('.pe-product-cart-button');
    const button = control?.querySelector(':scope > button');
    const label = control?.querySelector('.pe-button-text');
    const message = control?.querySelector('.pe-cart-message');
    const product = element.closest('[data-type="product"]');
    if (!button || !label || !message || !product) return;
    let variant = control.dataset.variant;
    let quantity = 1;
    const soldOut = new Set(control.dataset.soldOut.trim().split(/\s+/));
    const normalLabel = checkout ? window.gpCartStrings.buyNow : window.variantStrings.addToCart;
    const root = window.Shopify?.routes?.root || '/';
    message.setAttribute('role', 'alert');
    message.setAttribute('aria-live', 'polite');
    message.classList.add('gp-cart-message');

    function update() {
      const unavailable = !variant || soldOut.has(variant);
      const busy = product.dataset.gpCartBusy === 'true';
      button.disabled = unavailable || busy;
      button.setAttribute('aria-disabled', String(button.disabled));
      button.setAttribute('aria-busy', String(busy));
      button.classList.toggle('sold-out', unavailable);
      button.classList.toggle('processing', busy);
      label.textContent = unavailable ? window.variantStrings.soldOut : normalLabel;
      if (!checkout) {
        product.querySelectorAll('[data-gp-stock-variant]').forEach(stock => {
          stock.hidden = stock.dataset.gpStockVariant !== String(variant);
        });
      }
    }

    product.addEventListener('gp:cart-busy', update);
    window.pextStorage.put(element, 'updateQuantity', value => { quantity = value; });
    window.pextStorage.put(element, 'updateVariant', value => {
      variant = value;
      control.dataset.variant = value || '';
      message.textContent = '';
      message.classList.remove('show', 'failed');
      product.querySelectorAll('.pe-option-value[data-variants]').forEach(option => {
        option.setAttribute('aria-pressed', String(option.classList.contains('active')));
      });
      if (value && !checkout) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', value);
        window.history.replaceState({}, '', url);
      }
      update();
    });
    update();

    button.addEventListener('click', async () => {
      if (button.disabled || product.dataset.gpCartBusy === 'true') return;
      const quantityInput = product.querySelector('.pe-product-quantity input');
      const requestedQuantity = quantityInput ? Number(quantityInput.value) : Number(quantity);
      if (!Number.isSafeInteger(requestedQuantity) || requestedQuantity < 1) {
        quantityInput?.reportValidity();
        message.textContent = window.cartStrings.error;
        message.classList.add('show', 'failed');
        return;
      }
      const selectedVariant = variant;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const properties = {};
      product.querySelectorAll('input[name^="properties["]').forEach(input => {
        const key = input.name.match(/^properties\[(.+)\]$/)?.[1];
        if (key && input.value) properties[key] = input.value;
      });
      const payload = { items: [{ id: selectedVariant, quantity: requestedQuantity, properties }] };
      if (cart && !checkout) {
        payload.sections = cart.getSectionsToRender().map(section => section.id);
        payload.sections_url = window.location.pathname;
        cart.setActiveElement(button);
      }
      message.textContent = '';
      message.classList.remove('show', 'failed');
      product.dataset.gpCartBusy = 'true';
      product.dispatchEvent(new Event('gp:cart-busy'));
      let added = false;
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          const error = new Error();
          error.customerMessage = data.description || data.message || window.cartStrings.error;
          throw error;
        }
        added = true;
        if (checkout) {
          window.location.assign(root + 'checkout');
          return;
        }
        if (!cart || !data.sections || Object.values(data.sections).some(section => !section)) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        cart.renderContents({ ...data, ...(data.items?.[0] || {}), sections: data.sections });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gp-product-cart',
            productVariantId: selectedVariant,
            cartData: data
          })).catch(() => {});
        }
      } catch (error) {
        if (added) {
          window.location.assign(window.routes.cart_url);
        } else {
          message.textContent = error.customerMessage || window.cartStrings.error;
          message.classList.add('show', 'failed');
        }
      } finally {
        product.dataset.gpCartBusy = 'false';
        product.dispatchEvent(new Event('gp:cart-busy'));
      }
    });
  };
})();

(() => {
  function enhanceProductPanels() {
    if (document.querySelector('.pe-all-blue.editing')) return;
    document.querySelectorAll('.pe-product .pe-accordion-section').forEach((section, index) => {
      const handle = section.querySelector('.pe-accordion-handle');
      const panel = section.querySelector('.pe-accordion-panel');
      if (!handle || !panel) return;
      if (!panel.textContent.trim() && !panel.querySelector('img, video, iframe, input')) {
        section.hidden = true;
        return;
      }
      handle.setAttribute('role', 'button');
      handle.setAttribute('aria-label', handle.querySelector('.pe-title')?.textContent.trim() || handle.textContent.trim());
      handle.tabIndex = 0;
      panel.id ||= `gp-product-panel-${index}`;
      handle.setAttribute('aria-controls', panel.id);
      const sync = () => {
        const expanded = handle.classList.contains('active');
        handle.setAttribute('aria-expanded', String(expanded));
        panel.inert = !expanded;
        panel.setAttribute('aria-hidden', String(!expanded));
      };
      sync();
      new MutationObserver(sync).observe(handle, { attributes: true, attributeFilter: ['class'] });
      handle.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handle.click();
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceProductPanels);
  else enhanceProductPanels();
})();

